<!-- 采购结算申请数据操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form @submit.native.prevent class="baseForm" :show-message="false" id="mainInfo"
                                        label-width="150px" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                        <el-row v-if="dataActionBox.actionType != 2" ref="baseForm">
                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <el-date-picker v-if="formOneValue.fieldType == 'date'" size="mini"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                                    placeholder="选择日期" :clearable="false" :editable="false"
                                                    :isdisabled="formOneValue.isChange == 0"></el-date-picker>
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                <el-input  clearable
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                    :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                        slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                    </el-button>
                                                </el-input>
                                                </el-tooltip>
                                                <el-select clearable size="mini" class="form_codition" v-else-if="formOneValue.fieldType == 'formatter'" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                        placeholder="请选择">
                                                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                                                    </el-option>
                                                </el-select>
                                                <el-input v-else :disabled="formOneValue.isChange == 0"
                                                    @keyup.enter.native="nextFocus(formOneKey)"
                                                    v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2" ref="baseForm">
                                            <el-form-item :label="formOneValue.showField + ':'"
                                                :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <span v-if="formOneValue.fieldType == 'date'">{{
                                                    $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>

                                    <!-- 明细信息 -->
                                    <div>
                                        <el-form @submit.native.prevent :inline="true" size="mini" style="display:flex;">
                                            <div style="width:100%">
                                                <div id="operateBtn"
                                                    style="display:flex;justify-content: space-between;width:100%;">
                                                    <div v-if="dataActionBox.actionType == 0">
                                                        <el-button @click="extract('sendDataInfo')" type="primary"
                                                            size="mini">提取单据</el-button>
                                                        <el-button :disabled="sendDataInfo.detailList.length < 1"
                                                            @click="deleteDetails(2)" type="danger"
                                                            size="mini">删除</el-button>
                                                    </div>
                                                    <el-tag style="margin-right:10px;font-size:16px;"
                                                        type="warning">付款总金额:{{ sendDataInfo.totalMoney }}</el-tag>
                                                </div>
                                                <el-table size="mini" ref="mxTableRef2" :rosw-class-name="rowClassName"
                                                    :row-style="rowStyle" @row-click="clickEvent2"
                                                    @selection-change="handleSelectionChange2"
                                                    :data="sendDataInfo.detailList" border style="width: 100%"
                                                    :height="mxHeight" highlight-current-row>
                                                    <el-table-column label="选择操作" width="90"
                                                        v-if="dataActionBox.actionType == 0">
                                                        <template slot-scope="scope">
                                                            <el-radio v-model="selectedDataIndex" :label="scope.$index"
                                                                border size="mini">
                                                                <i class="el-icon-thumb"></i>
                                                            </el-radio>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column show-overflow-tooltip
                                                        :min-width="formOneValue.fieldWeight"
                                                        :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                        v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                                        v-if="formOneValue.isShow == 1">
                                                        <template slot-scope="scope">
                                                            <input class="newInput" @input="toMoney(scope.$index)"
                                                                :ref="formOneValue.entityField"
                                                                @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType != 2"
                                                                :min="scope.row.oldBalance > 0 ? 0 : scope.row.oldBalance"
                                                                :max="scope.row.oldBalance > 0 ? scope.row.oldBalance : 0"
                                                                type="number"
                                                                v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                                                :maxlength="$store.state.inputLength" />
                                                            <span
                                                                v-else>{{ sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</span>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <div>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')"
                            v-if="dataActionBox.actionType == 2">关闭</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                            v-if="dataActionBox.actionType == 0">保存</el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>

        <el-dialog :title="seTitle" v-if="DialogVisible2" :visible.sync="DialogVisible2" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple2" :id="searchId" :parentData="parentData"
                :parentSearchData="parentSearchData1" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "@/byComponents/SearchScheme.vue";
import SearchSchemeMultiple from "@/byComponents/SearchSchemeMultiple.vue";
export default {
    name: 'receivedvanceSettleAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        SearchSchemeMultiple
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            showTabs: '',
            mxHeight: 0,
            formDataList: [],
            tabForm: [],
            mxForm: [],
            footForm: [],
            selectedDataIndex: 0,
            sendDataInfo: {
                "detailList": [], //单据
            },
            parentData: {
                type: "dasmId",
                list: []
            },
            parentSearchData1: {
                cmId: "",
                opmId: "",
                salesId: "",
                coId: "",
                type: "",
            },
            seId: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            exWidth: "",
            DialogVisible: false,
            DialogVisible2: false,
            parentSearchData: {
                cmId: ''
            },
            searchId: '',
            seType: '',
            sField: '',
            selectedRow: [], // 当前已选择行
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.detailList": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalMoney = 0;
                newValue.forEach((item, keys) => {
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, item.settleMoney))
                });
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        toMoney(index) {
            if (this.sendDataInfo.detailList[index].settleMoney > this.sendDataInfo.detailList[index].oldBalance) {
                this.sendDataInfo.detailList[index].settleMoney = this.sendDataInfo.detailList[index].oldBalance
            } else if (this.sendDataInfo.detailList[index].settleMoney < 0) {
                this.sendDataInfo.detailList[index].settleMoney = 0
            }
            this.$forceUpdate()
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.detailList.forEach(item => {
                this.sendDataInfo.totalMoney = NP.plus(this.sendDataInfo.totalMoney, Number(item.settleMoney))
            })
        },
        extract(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                this.searchId = '779666991583232'
                // this.parentData.list = this.sendDataInfo.detailList
                for (const key in this.parentSearchData1) {
                    this.$set(this.parentSearchData1, key, this.sendDataInfo[key])
                }
                this.DialogVisible2 = true
            })
        },
        getSelect() {
            let mx = this.$refs.searchSchemeMultiple2.multipleSelection
            this.sendDataInfo.detailList = mx
            this.sendDataInfo.detailList.forEach(item => {
                item.settleMoney = ''
                this.$set(item, 'settleMoney', item.oldBalance)
            })
            this.DialogVisible2 = false
        },
        changeInputModel(val) {
            console.log(val,'valvalval')
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'sprmId') {
                    for (const key in this.sendDataInfo) {
                        if (key != 'detailList' && key != 'totalMoney') {
                            this.$set(this.sendDataInfo, key, val[key])
                        }
                    }
                } else {
                    this.paramValue(val)
                }
                // 处理 type 字段的回显（下拉框显示）
                if (val.type !== undefined) {
                    // 查找 type 对应的 formatter 类型字段
                    const typeField = this.formDataList[0].jurconfigform.find(
                        item => item.entityField === 'type' && item.fieldType === 'formatter'
                    );
                    if (typeField && typeField.fieldEntity) {
                        this.$set(this.sendDataInfo, typeField.fieldEntity, val.type);
                    }
                }
            }
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == '') return
            if (field == 'keydown') {
                if (index == this.sendDataInfo.detailList.length - 1) return
                if (this.sendDataInfo.detailList[index + 1] != undefined) {
                    this.selectedDataIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef2
                        this.$refs['settleMoney'][index + 1].focus() //跳退货数量
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.detailList[this
                            .selectedDataIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField) {
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.parentSearchData[type] = this.sendDataInfo[type]
            this.DialogVisible = true;
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        initActionBox(sendDataInfo) {
            if (this.dataActionBox.actionType == 2) return this.$emit('drawerCancel');
            this.$confirm('确定取消新增吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('drawerCancel')
                this.init()
                this.$refs.sendDataInfo.resetFields();
            }).catch(() => { });

        },
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            this.sendDataInfo.detailList = []
            this.sendDataInfo.unsettlement = 0
            this.sendDataInfo.totalMoney = 0
        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = JSON.parse(JSON.stringify(this.actionData.formData))
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
                for (let key in this.parentSearchData) {
                    this.parentSearchData[key] = ''
                }
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    // 检查是否是 formatter 类型的字段，如果是则转换为字符串
                    const formField = this.formDataList[0].jurconfigform.find(
                        item => item.entityField === key && item.fieldType === 'formatter'
                    );
                    if (formField) {
                        this.$set(this.sendDataInfo, key, String(dataInfo[key]));
                    } else {
                        this.$set(this.sendDataInfo, key, dataInfo[key]);
                    }
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    // 检查是否是 formatter 类型的字段，如果是则转换为字符串
                    const formField = this.formDataList[0].jurconfigform.find(
                        item => item.entityField === key && item.fieldType === 'formatter'
                    );
                    if (formField) {
                        this.$set(this.sendDataInfo, key, String(dataInfo[key]));
                    } else {
                        this.$set(this.sendDataInfo, key, dataInfo[key]);
                    }
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })

        },
        sendDataAction(sendDataInfo) {
            this.sub(sendDataInfo)
        },
        async sub(sendDataInfo) {
            if (this.sendDataInfo.detailList.length < 1) {
                return this.$message({
                    type: "error",
                    message: "单据不能为空",
                });
            }
            if (this.sendDataInfo.detailList.some((val) => val.settleMoney == 0 || val.settleMoney == '')) {
                this.$message({
                    type: "error",
                    message: "单据付款金额不能为0或者空",
                });
                return;
            }
            var sendData = {}
            var data2 = []
            sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            // this.sendDataInfo.detailList.forEach(item => {
            //     data2.push({
            //         dasmId: item.dasmId,
            //         settleMoney: item.settleMoney,
            //         oldBalance: item.oldBalance
            //     })
            // })
            // sendData.detailList = data2
            var responseData = await this.$http.getAddPreAccount(sendData)
            if (responseData.status == 200) {
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('drawerCancel')
                this.$refs.sendDataInfo.resetFields();

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        deleteDetails(type) {
            this.sendDataInfo.detailList.splice(this.selectedDataIndex, 1)
            this.selectedDataIndex = 0
        },

        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            mainFormList[0].jurconfigform.forEach(item => {
                if (item.fieldType == 'number') {
                    this.$set(this.sendDataInfo, item.entityField, 0)
                } else if (item.fieldType == 'search' && item.setField && item.setField != "") {
                    var arr = item.setField.split(',')
                    arr.forEach(item1 => {
                        this.$set(this.sendDataInfo, item1, "")
                    })
                } else {
                    this.$set(this.sendDataInfo, item.entityField, "")
                }
            })
            this.$set(this.sendDataInfo, "detailList", [])
            this.$set(this.sendDataInfo, "unsettlement", 0)
        },
        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
        },

        // 明细表格点击选中
        clickEvent2(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef2; // 获取表格对象
            let findRow = {}
            this.selectedDataIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange2(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
    },
    beforeDestroy() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.flex {
    display: flex;
    align-items: center;
}

.newInput {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.baseForm .el-row {
    display: flex;
    flex-wrap: wrap;
}

.baseForm ::v-deep .el-form-item--mini.el-form-item,
.baseForm ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px !important;
}

.baseForm ::v-deep .el-textarea__inner {
    width: 193px !important;
}

.baseForm ::v-deep .el-form-item__content {
    width: 193px !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 193px !important;
}</style>